import { useDraggable } from '@dnd-kit/core';
import React, {useEffect} from "react";
import { Field } from "../../../containers/QueryBuilder/types/Field";

export interface FieldItemDraggableProps {
    id: string
    field: Field
    onDrag?: (id: string) => void
    onDragEnd?: (id: string) => void
    children?: React.ReactNode
}

export const FieldItemDraggable = ({ id, field, onDrag, onDragEnd, children }: FieldItemDraggableProps) => {
    // const { attributes, listeners, setNodeRef, isDragging, over } = useDraggable({
    const { isDragging, attributes, listeners, setNodeRef} = useDraggable({
        id: `draggable-${field.code}`,
        data: { from: id, field: field },
    })

    useEffect(() => {
        if (isDragging) {
            onDrag && onDrag(`draggable-${field.code}`);
        } else {
            onDragEnd && onDragEnd(`draggable-${field.code}`);
        }
    }, [isDragging, onDrag, onDragEnd, field.code])

    // TODO: this works but we want this on the overlay
    // const isOverAndDisabled = isDragging && over && over.data.current && !over.data.current.enabled

    return (
        <div ref={setNodeRef} {...attributes} {...listeners}>
            {children}
        </div>
    )
}